function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import { node, oneOf } from 'prop-types';
import { GEL_SPACING_SEXT } from '@bbc/gel-foundations/spacings';
import { GEL_GROUP_2_SCREEN_WIDTH_MIN, GEL_GROUP_2_SCREEN_WIDTH_MAX } from '@bbc/gel-foundations/breakpoints';
/* Convert C_POSTBOX to rgba as IE doesn't like 8 digit hex */

var C_POSTBOX_TRANSPARENT = "rgba(184, 0, 0, 0)";
var C_POSTBOX_OPAQUE = "rgba(184, 0, 0, 1)";
var StyledScrollableNav = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledScrollableNav",
  componentId: "sc-1nc6e54-0"
})(["@media (max-width:", "){white-space:nowrap;overflow-x:scroll;scroll-behavior:auto;-webkit-overflow-scrolling:touch;scrollbar-width:none;-ms-overflow-style:none;&::-webkit-scrollbar{display:none;}&:after{content:' ';height:100%;width:", ";@media (min-width:", "){width:6rem;}position:absolute;", " bottom:0;z-index:3;overflow:hidden;pointer-events:none;background:linear-gradient( ", ",", " 0%,", " 100% );}}"], GEL_GROUP_2_SCREEN_WIDTH_MAX, GEL_SPACING_SEXT, GEL_GROUP_2_SCREEN_WIDTH_MIN, function (_ref) {
  var dir = _ref.dir;
  return css(["", ":0;"], dir === 'ltr' ? 'right' : 'left');
}, function (_ref2) {
  var dir = _ref2.dir;
  return dir === 'ltr' ? 'to right' : 'to left';
}, C_POSTBOX_TRANSPARENT, C_POSTBOX_OPAQUE);
export var ScrollableNavigation = function ScrollableNavigation(_ref3) {
  var children = _ref3.children,
      dir = _ref3.dir,
      props = _objectWithoutProperties(_ref3, ["children", "dir"]);

  return /*#__PURE__*/React.createElement(StyledScrollableNav, _extends({
    dir: dir
  }, props), children);
};
ScrollableNavigation.propTypes = {
  children: node.isRequired,
  dir: oneOf(['ltr', 'rtl'])
};
ScrollableNavigation.defaultProps = {
  dir: 'ltr'
};
export default ScrollableNavigation;